document.addEventListener('DOMContentLoaded', () => {
  function hidePrice() {
    const prices = document.querySelectorAll('.swym-product-final-price');

    if (prices.length === 0) {
      return;
    }

    prices.forEach((price) => {
      let priceText = price.textContent.trim();
      let numericPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      if (numericPrice === 0 || numericPrice >= 9000000) {
        let parent = price.closest('.swym-wishlist-item, .swym-wishlist-product-detail-text-container');

        if (parent) {
          price.remove();
          let addToCartBtn = parent.querySelector('.swym-button');
          if (addToCartBtn) {
            addToCartBtn.remove();
          }
        }
      }
    });
  }

  setTimeout(hidePrice, 2000);
  const observer = new MutationObserver((mutations) => {
    handlePriceRemoval();
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        hidePrice();
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', hidePrice);
  document.addEventListener('scroll', hidePrice);

  function handlePriceRemoval() {
    document.querySelectorAll('.swym-product-price').forEach((priceElement) => {
      const addToCartBtn = priceElement.parentElement.querySelector('.swym-add-to-cart-btn');

      if (
        addToCartBtn &&
        (addToCartBtn.getAttribute('aria-label') === 'Sold Out' || addToCartBtn.classList.contains('swym-disabled'))
      ) {
        priceElement.remove();
      }
    });
  }
  document.addEventListener('DOMContentLoaded', handlePriceRemoval);
});
